/// <reference path="../../BaseNew/GAdmDetailBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdeTridaAkce extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdeTridaAkceReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdeTridaAkceObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdeTridaAkceObj());
            this.detailObj.createBase({
                contentName: "detailAdeTridaAkce",
                contentCaption: "jres:33000403", //RC 33000403 : Třída akce
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdeTridaAkce", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }

    export class DetailAdeTridaAkceObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdeTridaAkceReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0}".format((this.data.nazev) ? this.data["nazev"] : "")
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.ixs_tri) ? this.data.ixs_tri : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdeTridaAkceSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdeTridaAkce.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdeTridaAkce", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdeTridaAkce.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actOpenSeznamAdmVlastnostObecnyObjekt*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_tri")
            this.MakeField("nazev")
            this.MakeField("zkratka")
            this.MakeField("poznamka")
            this.MakeField("rok_od", {
                validators: [
                    new Gordic.Validators.Required({ stopping: true }),
                    new Gordic.Validators.Range({ min: 1900, max: 2050 }),
                    this.createSpecialValidator()
                ]
            })
            this.MakeField("rok_do", {
                validators: [
                    new Gordic.Validators.Required({ stopping: true }),
                    new Gordic.Validators.Range({ min: 1900, max: 2050 })
                ]
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private createSpecialValidator(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000137" });
            validator.stopping = true;
            validator.validate = (value, source) => {
                var form = this.cnt.findForms("{0}form".format(this.options.contentName));
                var rokOd = form.findFields("rok_od").gfield("getValue");
                var rokDo = form.findFields("rok_do").gfield("getValue");
                if (rokOd <= rokDo)
                    return true;
                return false;
            }
            return validator;
        }
    }
}